import { Input, InputOnChangeData, InputProps } from "@fluentui/react-components";
import React, { useCallback } from "react";
import { TFieldWrapperComponentProps } from "./WithFormFieldWrapper.types";
import { WithFormFieldWrapper } from "./WithFormFieldWrapper";

import { observer } from "mobx-react";

export type IM365PulseFormInputProps = TFieldWrapperComponentProps<Omit<InputProps, "value" | "defaultValue" | "onChange">>;

const M365PulseFormInputFieldBase = (props: IM365PulseFormInputProps) => {
    const {
        formikFieldProps: {
            field: { value },
            form: { setFieldValue }
        },
        name,
        ...restProps
    } = props;

    const onChange = useCallback(
        (ev: React.ChangeEvent<HTMLInputElement>, data: InputOnChangeData) => {
            if (props.type === "number") {
                setFieldValue(name, Number(data.value));
                return;
            }
            setFieldValue(name, data.value);
        },
        [name, props.type, setFieldValue]
    );

    return <Input value={value ?? ""} onChange={onChange} {...restProps} />;
};

export const M365PulseFormInputField = observer(WithFormFieldWrapper(M365PulseFormInputFieldBase));
